import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { MatIconModule } from '@angular/material/icon';
import { AsyncPipe, NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, HostBinding, Input, inject } from '@angular/core';

import { isEskoHostname } from '@shared/utilities/branding.utilities';

import { BrandingManagerService } from '@player/shared/services/branding-manager.service';

@Component({
  selector: 'brand-wordmark',
  templateUrl: './brand-wordmark.component.html',
  styleUrls: ['./brand-wordmark.component.scss'],
  imports: [MatIconModule, NgClass, AsyncPipe],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BrandWordmark {
  readonly bm = inject(BrandingManagerService);

  @Input()
  @HostBinding('class')
  class: string;

  @Input()
  color: string = null;

  readonly isEsko$: Observable<boolean> = this.bm.branding.pipe(
    map((branding) => (branding ? branding.name === 'Esko' : isEskoHostname())),
  );
}
